export const melanges = [
  {
    id: 'rouge-obsidienne',
    nom: 'Rouge Obsidienne',
    description: 'Mélange volcanique fumé et piquant pour rajouter de l\'intensité à tous vos plats.',
    image: '/images/rouge-obsidienne.jpg',
    composition: [
      {
        nom: 'Sel noir de lave',
        image: '/images/sel-noir-lave.jpg',
        bienfaits: 'Riche en minéraux, apporte une saveur unique et une couleur sombre'
      },
      {
        nom: 'Poivre long de Lampong',
        image: '/images/poivre-lampong.jpg',
        bienfaits: 'Saveur chaude et complexe, moins piquant que le poivre noir classique'
      },
      {
        nom: 'Poivre de Madagascar',
        image: '/images/poivre-madagascar.jpg',
        bienfaits: 'Poivre noir intense et aromatique, saveur chaude et équilibrée'
      },
      {
        nom: 'Paprika fumé',
        image: '/images/paprika-fume.jpg',
        bienfaits: 'Apporte une note fumée caractéristique et une couleur rouge intense'
      },
      {
        nom: 'Ail semoule',
        image: '/images/ail-semoule.jpg',
        bienfaits: 'Saveur profonde et réconfortante, parfait pour les viandes'
      },
      {
        nom: 'Nigelle',
        image: '/images/nigelle.jpg',
        bienfaits: 'Graines aux notes d\'oignon et de poivre, apporte du croquant'
      },
      {
        nom: 'Gingembre',
        image: '/images/gingembre.jpg',
        bienfaits: 'Saveur chaude et piquante, apporte du dynamisme et de la fraîcheur'
      },
      {
        nom: 'Cumin',
        image: '/images/cumin.jpg',
        bienfaits: 'Saveur chaude et terreuse, parfait pour les viandes grillées'
      }
    ],
    idealesAvec: [
      'Viande grillée',
      'Poisson blanc',
      'Sauce tomate',
      'Légumes racines rôtis',
      'Agneau longue cuisson',
      'Champignon'
    ],
    recettes: [
      {
        titre: "Épaule d'agneau en croûte volcanique",
        description: "Épaule d'agneau rôtie lentement, enrobée d'une croûte Rouge Obsidienne puissante, épicée et minérale. Une ode à la braise et à la terre.",
        image: "/images/epaule-agneau-croute-volcanique.jpg",
        details: {
          ingredients: [
            "1 épaule d'agneau entière (1,4 à 1,6 kg), désossée ou non",
            "3 c. à soupe de Rouge Obsidienne (Kaza)",
            "2 gousses d'ail, hachées",
            "1 c. à soupe de gingembre frais râpé",
            "2 c. à soupe d'huile d'olive vierge extra",
            "1 c. à café de miel ou de mélasse de grenade (optionnel, pour adoucir)",
            "1 branche de romarin frais",
            "(Facultatif : un trait de jus de citron vert ou de vinaigre de datte pour la touche finale)"
          ],
          preparation: [
            "Prépare la marinade la veille : Mélange l'huile d'olive, le miel ou la mélasse, l'ail haché, le gingembre frais et les 3 c. à soupe de Rouge Obsidienne. Badigeonne généreusement l'épaule d'agneau, masse bien pour former une couche rouge foncée. Laisse reposer au réfrigérateur au moins 4h, idéalement une nuit, filmée.",
            "Cuisson lente : Préchauffe le four à 170°C (chaleur tournante). Dépose l'épaule dans un plat sur un lit de romarin et/ou d'oignons. Couvre hermétiquement (papier cuisson + alu ou cocotte fermée). Enfourne pour 2h30.",
            "Croûte finale : Retire le couvercle, monte la température à 200°C. Arrose avec le jus de cuisson, puis laisse caraméliser 15 à 20 min pour une croûte sombre et épicée. Laisse reposer 10 min hors du four, sous papier alu."
          ],
          accompagnements: [
            "Écrasé de patates douces au citron vert",
            "Purée de haricots blancs à l'huile fumée",
            "Semoule d'épeautre au cumin noir et herbes fraîches"
          ],
          boissons: [
            "Vin rouge intense (syrah, madiran, malbec)",
            "Bière noire fumée artisanale",
            "Infusion glacée de thym-citron, gingembre et miel"
          ],
          variante: "Variante express : Avec des tranches épaisses de gigot d'agneau, même marinade, poêle très chaude 3 min/face pour saisir, finition au four à 180°C, 10 min.",
          astuce: "Rouge Obsidienne peut aussi s'utiliser en assaisonnement final pour des légumes grillés, sur du tofu ou du halloumi en snack grillé, ou en touche dans une huile d'olive chaude pour un pain trempé ultra-sensuel."
        }
      },
      {
        titre: "Filet de poisson laqué au KAZA – Rouge Obsidienne",
        description: "Le plat qui transforme un simple poisson en expérience volcanique. Grâce au mélange KAZA, plus besoin d'ajouter quoi que ce soit. Juste du feu et un filet.",
        image: "/images/filet-poisson-laque.jpg",
        details: {
          ingredients: [
            "2 filets de cabillaud ou autre poisson blanc ferme (200-250g chacun)",
            "2 c. à café bombées de KAZA Rouge Obsidienne (clé de la recette)",
            "1 c. à soupe de sauce soja",
            "1 c. à soupe de miel (ou sirop d'érable)",
            "Le jus d'1/2 citron vert",
            "1 c. à soupe d'huile neutre pour la cuisson"
          ],
          preparation: [
            "Mélange magique : Dans un bol, combine 2 c. à café de KAZA Rouge Obsidienne, 1 c. à soupe de miel, 1 c. à soupe de sauce soja, jus de citron vert et 1 c. à soupe d'eau chaude pour détendre la sauce.",
            "Saisie express : Fais chauffer l'huile dans une poêle. Saisis les filets 1 min de chaque côté à feu vif, juste pour marquer la surface.",
            "Laquage intense : Baisse le feu. Verse la laque sur le poisson. Couvre et laisse cuire encore 3 à 4 min à feu doux. Arrose régulièrement pour que la sauce s'épaississe et caramélise légèrement.",
            "Dressage : Sers avec un zeste de citron vert, quelques herbes fraîches, et un riz nature ou coco pour absorber la sauce."
          ],
          pourquoi: "KAZA apporte la fumée, le piment, la profondeur et l'équilibre. Il fait le job d'au moins 5 épices et condiments en une seule cuillère. Tu n'as ni besoin de saler, ni d'ajouter quoi que ce soit d'autre : il fait tout. Un seul pot. Une recette. Une signature gustative unique.",
          bonusChef: "Ajoute 1 c. à café de yaourt ou crème épaisse dans le fond de l'assiette pour un contraste froid/chaud, douceur/piquant… et KAZA explose encore plus.",
          accompagnements: [
            "Riz coco citron vert",
            "Pickles de mangue verte ou de chou rouge",
            "Sauce yaourt ou crème coco citronnée",
            "Quelques herbes fraîches (coriandre, menthe)"
          ],
          boissons: [
            "Vin blanc légèrement boisé et minéral (Chardonnay du Jura ou blanc volcanique des Canaries)",
            "Bière blanche épicée type witbier ou blanche gingembre",
            "Cocktail Mezcal tonic, citron vert & glaçons",
            "Infusion glacée rooibos, gingembre, citron vert & laurier (sans alcool)",
            "Citronnade maison au poivre noir & thym citron (sans alcool)"
          ],
          dressage: "Assiette plate foncée (gris ardoise ou noir mat). Pose le riz en cercle à l'emporte-pièce. Filet laqué sur le côté, nappé d'un peu de jus restant. Légumes croquants posés en chemin. Un zeste de citron vert + quelques micro-pousses ou herbes fraîches. Pour un effet spectaculaire, fume l'assiette."
        }
      },
      {
        titre: 'Tatin de pleurotes caramélisés',
        description: 'Champignons revenus puis caramélisés au Rouge Obsidienne, servis en tatin renversée sur pâte feuilletée.',
        image: '/images/tatin-pleurotes-caramelises.jpg',
        details: {
          ingredients: [
            '250 g de pleurotes bien charnues (ou shiitakés)',
            '2 c. à café bombées de KAZA Rouge Obsidienne',
            '1 pâte feuilletée pur beurre (ou vegan)',
            '1 c. à soupe de miel ou sirop d\'agave',
            '1 c. à soupe de sauce soja',
            '1 noisette de beurre ou d\'huile végétale',
            '1 c. à soupe d\'eau',
            'Poivre du moulin (facultatif)'
          ],
          preparation: [
            'Nettoie les pleurotes, déchire-les grossièrement à la main.',
            'Fais-les revenir à feu vif dans un peu de matière grasse pendant 4-5 min jusqu\'à ce qu\'ils soient bien dorés et légèrement croustillants sur les bords. Réserve.',
            'Dans une poêle (ou petit moule à tatin anti-adhésif), mélange : 2 c. à café de KAZA Rouge Obsidienne, 1 c. à soupe de miel, 1 c. à soupe de sauce soja, 1 c. à soupe d\'eau. Fais réduire à feu moyen pour obtenir une sauce sirupeuse et bien brillante.',
            'Ajoute les champignons dans le caramel directement dans le fond du moule. Tasse légèrement.',
            'Dépose la pâte feuilletée dessus, en rentrant bien les bords.',
            'Enfourne à 200°C pendant 20-25 min jusqu\'à ce que la pâte soit bien dorée et gonflée.',
            'Attends 2 min à la sortie du four, puis retourne la tatin sur une assiette plate. Admire les champignons laqués, fondants et brillants comme du confit fumé.'
          ],
          pourquoi: 'KAZA fait la sauce, le sel, le punch et la complexité tout seul. Il transforme une simple base caramel-soja en une laque gastronomique et addictive. Il s\'infuse dans les champignons comme une fumée en cuisine ouverte. Tu pourrais tenter cette tatin avec n\'importe quelle autre épice… mais tu ne retrouveras jamais cet équilibre.',
          bonusChef: 'Ajoute quelques noisettes concassées grillées ou des copeaux de vieux comté au moment du dressage pour encore plus de texture et de caractère.',
          accompagnements: [
            'Salade fraîche de fenouil ou de céleri rave à la pomme',
            'Purée de patate douce ou de topinambour',
            'Yaourt fumé au citron (si tu veux une touche acide douce)'
          ],
          boissons: [
            'Vin orange ou blanc macéré (viognier nature ou macabeu)',
            'Bière brune légère ou ambrée, avec des notes toastées',
            'Cocktail whisky sour fumé, citron & sirop d\'érable',
            'Infusion glacée hibiscus / romarin / citron (sans alcool)',
            'Eau pétillante aux zestes d\'orange sanguine + sirop de thym (sans alcool)'
          ],
          dressage: 'Assiette noire ou en terre brute. Tatin au centre, bien brillante. Quelques pousses de moutarde ou jeunes feuilles vertes pour la fraîcheur. Un filet d\'huile d\'olive fumée en finition ou un zeste de citron jaune pour faire briller le tout. Pour le wow final : sers sous cloche fumée et dévoile à tes convives. KAZA fait le show.'
        }
      },
      {
        titre: 'Poulet rôti façon yakitori',
        description: 'Cuisse de poulet saisie puis mijotée dans une laque Rouge Obsidienne pour un goût fumé et laqué unique.',
        image: '/images/poulet-roti-yakitori.jpg',
        details: {
          ingredients: [
            '2 cuisses de poulet (ou hauts de cuisse désossés pour une version plus rapide)',
            '2,5 c. à café bombées de KAZA Rouge Obsidienne',
            '1 c. à soupe de sauce soja',
            '1 c. à soupe de miel ou mirin',
            '1 c. à soupe d\'eau',
            '1 filet d\'huile neutre (tournesol, colza)',
            '1 gousse d\'ail (optionnel)',
            '1/2 citron vert ou jaune'
          ],
          preparation: [
            'Dans une poêle ou cocotte, fais dorer les cuisses dans un filet d\'huile. Objectif : une belle peau dorée, croustillante, pas de cuisson complète. Réserve.',
            'Dans un petit bol, mélange : 2,5 c. à café de KAZA Rouge Obsidienne, 1 c. à soupe de sauce soja, 1 c. à soupe de miel, 1 c. à soupe d\'eau. (Option : râpe un peu d\'ail pour booster la profondeur)',
            'Replace le poulet dans la poêle, verse la laque dessus, couvre et laisse mijoter à feu doux 20 à 25 min. Retourne et arrose régulièrement pour bien enrober la viande → la sauce devient brillante et épaisse.',
            'Un filet de jus de citron pour trancher le sucré fumé. Zeste si tu veux faire briller le tout juste avant d\'envoyer.'
          ],
          pourquoi: 'KAZA remplace le gingembre, l\'ail, le piment, le fumé, le sel et le bouillon. Il transforme un plat simple en assiette de caractère, sans jamais être agressif. Il crée une croûte laquée unique grâce au sucre, à la cuisson lente et à ses arômes puissants. Une seule épice. Une sauce. Un souvenir.',
          bonusChef: 'Tu veux une version foodporn ? Déchiquette la viande à la fin et sers-la en bun vapeur façon bao, avec des pickles et un peu de crème coco. 💣',
          accompagnements: [
            'Riz blanc japonais ou riz gluant',
            'Chou mariné ou carottes râpées au vinaigre doux',
            'Sauce au yaourt-citron ou crème sésame pour apaiser le feu',
            'Cacahuètes grillées concassées ou sésame torréfié'
          ],
          boissons: [
            'Saké sec ou vin blanc vif (type Sancerre ou riesling sec)',
            'Bière blonde japonaise ou IPA florale',
            'Cocktail gin tonic citron-yuzu',
            'Eau pétillante citron vert & sirop gingembre (sans alcool)',
            'Thé glacé jasmin-citron ou matcha adouci à la poire (sans alcool)'
          ],
          dressage: 'Assiette creuse ou plateau bois façon bento. Riz moulé à l\'emporte-pièce. Poulet nappé de sauce KAZA, zeste de citron, touche de sésame. Accompagnements disposés façon "chemin", pickles à part. Option wow : torche légèrement la peau du poulet au chalumeau ou sous le grill → effet yakitori garanti 🍢.'
        }
      },
      {
        titre: 'Smash Burger épicé',
        description: 'Steak pressé assaisonné à cœur avec Rouge Obsidienne, cheddar fondu et sauce fraîche en contraste.',
        image: '/images/smash-burger-epice.jpg',
        details: {
          ingredients: [
            '300g de bœuf haché (15% de MG min), en 2 boules de 150g',
            '2 c. à café bombées de KAZA Rouge Obsidienne',
            '2 pains briochés à burger',
            '2 tranches épaisses de cheddar affiné',
            'Quelques tranches de pickles (maison ou du commerce)',
            '2 c. à soupe de yaourt grec ou skyr',
            'Le jus d\'1/4 de citron',
            '1 c. à café de moutarde douce ou à l\'ancienne',
            'Un peu de beurre ou d\'huile neutre'
          ],
          preparation: [
            'Mélanger délicatement le bœuf haché avec 2 c. à café de KAZA, sans trop compacter, et former deux boules bien rondes',
            'Préparer la sauce fraîche : yaourt + citron + moutarde + une mini-pincée de KAZA',
            'Faire griller les pains à sec ou avec un peu de beurre dans une poêle bien chaude',
            'Faire chauffer une plaque ou poêle en fonte bien chaude',
            'Déposer une boule de viande et l\'écraser fort avec une spatule jusqu\'à obtenir un disque très fin avec bords croustillants',
            'Laisser saisir 1 à 2 min sans toucher, puis retourner, ajouter une tranche de cheddar, couvrir et laisser fondre 30 sec',
            'Monter le burger : pain grillé → sauce → pickles → steak cheesy → encore un peu de sauce → chapeau'
          ],
          accompagnements: [
            'Frites maison au paprika doux ou patate douce',
            'Coleslaw acidulé (chou rouge + vinaigre + sucre + graines)',
            'Cornichons ou pickles maison',
            'Chips maison au four avec zeste de citron'
          ],
          boissons: [
            'Bière IPA ou Pale Ale fruitée, type NEIPA',
            'Cidre brut fermier bien sec',
            'Cocktail tequila fumée + citron vert + ginger beer'
          ]
        }
      },
      {
        titre: 'Ceviche mangue & poisson blanc',
        description: 'Poisson cru mariné avec mangue, daikon et Rouge Obsidienne pour un plat cru mais brûlant d\'émotions.',
        image: '/images/ceviche-mangue-poisson.jpg',
        details: {
          ingredients: [
            '180 g de poisson blanc ultra frais (maigre, bar, dorade ou cabillaud)',
            '1 mangue mûre mais ferme (ou mangue verte pour plus d\'acidité)',
            '1 petit daikon (ou radis rose) émincé très fin',
            '1/2 oignon rouge, tranché très fin',
            '2 c. à café bombées de KAZA Rouge Obsidienne',
            'Le jus d\'1 citron vert',
            'Le zeste du même citron',
            '1 c. à soupe d\'huile d\'olive douce',
            '1/2 c. à café de sirop d\'érable ou miel (optionnel)',
            'Quelques feuilles de coriandre fraîche',
            'Graines de sésame noir ou cacahuètes grillées concassées'
          ],
          preparation: [
            'Couper le poisson en petits cubes de 1 cm',
            'Émincer la mangue, le daikon et l\'oignon en fines lamelles ou en julienne',
            'Dans un bol, mélanger le poisson cru, la mangue, le daikon, l\'oignon, le jus de citron, l\'huile, le sirop et 2 c. à café de KAZA Rouge Obsidienne',
            'Laisser mariner 10 à 12 minutes au frais',
            'Juste avant de servir, ajouter le zeste de citron vert',
            'Rectifier si besoin en citron ou KAZA selon le feu intérieur',
            'Parsemer de coriandre fraîche et de graines de sésame ou cacahuètes'
          ],
          accompagnements: [
            'Chips de riz soufflé, pain pita toasté ou crackers aux graines',
            'Shot de jus gingembre–citron à côté',
            'Quelques feuilles de shiso ou herbes asiatiques'
          ],
          boissons: [
            'Vin blanc sec aromatique (muscat sec, riesling, sauvignon)',
            'Cocktail pisco sour ou margarita twistée au mezcal',
            'Saké léger & sec bien frais'
          ]
        }
      },
      {
        titre: 'Crème brûlée vanille & flamme Rouge',
        description: 'Crème vanille classique avec une croûte caramélisée au sucre et Rouge Obsidienne pour une fin de repas inoubliable.',
        image: '/images/creme-brulee-flamme-rouge.jpg',
        details: {
          ingredients: [
            '40 cl de crème liquide entière',
            '10 cl de lait entier',
            '1 gousse de vanille ou 1 c. à café d\'extrait',
            '4 jaunes d\'œufs',
            '80 g de sucre',
            '4 c. à café de sucre roux (cassonade)',
            '1 c. à café rase de KAZA – Rouge Obsidienne'
          ],
          preparation: [
            'Faire chauffer crème + lait + vanille jusqu\'à frémissement et laisser infuser 10 min hors du feu',
            'Fouetter les jaunes + sucre et les blanchir légèrement',
            'Verser doucement le mélange crème/lait tiédi, sans faire mousser',
            'Verser dans 4 ramequins',
            'Cuisson au bain-marie, 1h à 110°C, four préchauffé (ou 30-35 min à 140°C)',
            'Laisser refroidir puis réserver minimum 3h au frigo (idéal : la veille)',
            'Mélanger le sucre roux + Rouge Obsidienne',
            'Saupoudrer uniformément chaque ramequin',
            'Caraméliser au chalumeau jusqu\'à obtenir une croûte craquante'
          ],
          accompagnements: [
            'Pincée de Rouge Obsidienne non caramélisé en finition pour l\'effet "poussière volcanique"',
            'Mini cuillère dorée pour un effet Instagram',
            'Servir sur ardoise ou planche brute'
          ],
          boissons: [
            'Rivesaltes ambré ou Pineau des Charentes',
            'Liqueur de café légèrement amère',
            'Espresso martini au mezcal'
          ]
        }
      },
      {
        titre: 'Raviolis ouverts au bœuf braisé, écume fumée & Rouge Obsidienne',
        description: 'Pour 4 personnes — Un plat spectaculaire : un bœuf effiloché ultra-fondant sur feuilles de pâte, nappé d\'une écume chaude au parfum volcanique.',
        image: '/images/raviolis-boeuf-rouge-obsidienne.jpg',
        details: {
          ingredients: [
            '600 g de paleron',
            '1 oignon, 2 gousses d\'ail',
            '1 c. à soupe de Rouge Obsidienne',
            '20 cl de vin rouge',
            '30 cl de bouillon',
            '8 grandes feuilles de pâte à raviolis frais',
            '20 cl de crème liquide',
            '1 c. à café de paprika fumé (optionnel)',
            'Huile d\'olive, sel léger'
          ],
          preparation: [
            'Braisage volcanique : Saisis le paleron, ajoute oignon, ail, Rouge Obsidienne, vin rouge, bouillon. Couvre, 2h30 feu doux. Effiloche.',
            'Pâte ouverte : Plonge chaque grande feuille 20 sec dans l\'eau bouillante. Étale-les séparément.',
            'Écume fumée : Chauffe la crème + une pincée de Rouge Obsidienne → mixe au plongeant pour obtenir une mousse légère.',
            'Montage : Dépose un nid de bœuf effiloché sur chaque feuille.',
            'Explosion finale : Verse l\'écume brûlante juste avant de servir.'
          ],
          accompagnements: [
            'Salade de cresson • Pickles d\'oignons rouges.'
          ],
          boissons: [
            'Vin rouge volcanique (Sicile) • Porter fumée • Thé noir fumé.'
          ],
          pourquoi: 'Il fusionne parfaitement avec le bœuf braisé : fumée + minéralité + piquant = relief incroyable.',
          bonusChef: 'Flambe le bœuf avec un trait de mezcal juste avant l\'envoi.',
          dressage: 'Feuille ouverte façon éventail, bœuf au centre, écume en voile.'
        }
      },
      {
        titre: 'Cabillaud caramélisé au miso, laque volcanique Rouge Obsidienne',
        description: 'Pour 4 personnes — Sucré-salé-fumé-piquant : une laque brillante, épaisse, addictive, qui enrobe le poisson comme une coulée de lave.',
        image: '/images/cabillaud-miso-rouge-obsidienne.jpg',
        details: {
          ingredients: [
            '4 dos de cabillaud',
            '1,5 c. à café de Rouge Obsidienne',
            '1 c. à soupe de miso brun',
            '1 c. à soupe de miel',
            '1 c. à soupe de sauce soja',
            '1 c. à soupe d\'eau chaude',
            '1 c. à soupe d\'huile'
          ],
          preparation: [
            'Laque volcanique : Miso + miel + soja + eau chaude + Rouge Obsidienne → mélange brillant.',
            'Saisie rapide : Poêle chaude, huile → cabillaud 1 min par face.',
            'Caramélisation : Baisse feu → ajoute laque → 3 min, arrosage constant.',
            'Four flash : Termine 2 min à 200°C pour figer la brillance.',
            'Repos : 1 min avant de servir pour stabiliser la laque.'
          ],
          accompagnements: [
            'Purée de patate douce • Légumes verts vapeur • Riz coco.'
          ],
          boissons: [
            'Saké sec • Vin blanc fumé • Ginger beer.'
          ],
          pourquoi: 'Le miso accentue sa profondeur fumée et son piquant minéral : un accord magistral.',
          bonusChef: 'Un trait de citron vert juste avant de servir → éclat immédiat.',
          dressage: 'Assiette noire, filet brillant façon miroir, herbes fines et graines de nigelle.'
        }
      },
      {
        titre: 'Tartare brûlé de betterave & burrata fumée Rouge Obsidienne',
        description: 'Pour 4 personnes — Un plat végétal incendiaire : betterave en tartare chaud-froid, burrata légèrement fumée et épices volcaniques.',
        image: '/images/tartare-betterave-burrata-rouge-obsidienne.jpg',
        details: {
          ingredients: [
            '3 grosses betteraves cuites',
            '1 burrata',
            '1 c. à café de Rouge Obsidienne',
            '1 c. à soupe d\'huile d\'olive',
            '1 c. à café de vinaigre balsamique',
            'Zeste d\'une orange',
            'Sel léger'
          ],
          preparation: [
            'Tartare : Coupe la betterave en petits dés → huile, balsamique, zeste.',
            'Brûlure contrôlée : Poêle très chaude → dépose une poignée de tartare 20 sec pour créer un choc fumé. Mélange au reste.',
            'Burrata fumée : Saupoudre légèrement Rouge Obsidienne sur la burrata, fais un passage de fumoir ou cloche fumée (facultatif).',
            'Montage : Tartare + burrata au centre.',
            'Finition volcanique : Rouge Obsidienne en micro-pincée sur le dessus.'
          ],
          accompagnements: [
            'Pain de campagne grillé, salade d\'herbes anisées.'
          ],
          boissons: [
            'Pinot noir léger • Bière rouge • Cocktail mezcal-orange.'
          ],
          pourquoi: 'Il intensifie la betterave, lui donne profondeur, feu, minéralité.',
          bonusChef: 'Ajoute quelques gouttes d\'huile de sésame → dimension grillée sublime.',
          dressage: 'Assiette blanche, cercle parfait de tartare, burrata posée en sphère.'
        }
      },
      {
        titre: 'Nouilles sautées au beurre noir, citron confit & Rouge Obsidienne',
        description: 'Pour 4 personnes — Un plat fusion dément : beurre noir noisette brûlant + citron confit + Rouge Obsidienne = explosion totale.',
        image: '/images/nouilles-beurre-noir-rouge-obsidienne.jpg',
        details: {
          ingredients: [
            '300 g de nouilles (udon ou ramen)',
            '80 g de beurre',
            '1 c. à café bombée de Rouge Obsidienne',
            '1 c. à soupe de citron confit haché',
            '2 c. à soupe de sauce soja',
            '1 gousse d\'ail',
            'Ciboule, graines de sésame'
          ],
          preparation: [
            'Cuisson nouilles : Égoutte et réserve.',
            'Beurre noir : Chauffe beurre + ail jusqu\'à légère coloration noisette.',
            'Signature volcanique : Hors feu → Rouge Obsidienne + citron confit.',
            'Sautage : Remets les nouilles → soja → mélange énergique.',
            'Finition : Ciboule + sésame.'
          ],
          accompagnements: [
            'Concombre acidulé, brocolis vapeur citronnés.'
          ],
          boissons: [
            'Saké chaud • IPA légère • Eau gazeuse au citron.'
          ],
          pourquoi: 'Le beurre noisette exalte la fumée et le piquant, le citron confit apporte la lumière.',
          bonusChef: 'Ajoute un filet de miel pour un équilibre sucré–fumé magique.',
          dressage: 'Bol asiatique, nouilles brillantes, ciboule verte en pluie.'
        }
      },
      {
        titre: 'Gaufres salées au maïs grillé, crème fumée & Rouge Obsidienne',
        description: 'Pour 4 personnes — Une création audacieuse : gaufres crousti-fondantes au maïs brûlé, servies avec une crème fouettée fumée et pimentée.',
        image: '/images/gaufres-mais-rouge-obsidienne.jpg',
        details: {
          ingredients: [
            '200 g de farine',
            '2 œufs',
            '30 cl de lait',
            '80 g de maïs grillé',
            '40 g de beurre fondu',
            '½ c. à café de Rouge Obsidienne',
            '200 g de crème fraîche épaisse',
            '½ c. à café de Rouge Obsidienne (pour la crème)',
            '1 c. à soupe de jus de citron'
          ],
          preparation: [
            'Maïs grillé : Poêle très chaude, fais griller le maïs jusqu\'à brunissement.',
            'Appareil à gaufre : Mélange farine, œufs, lait, beurre, maïs, épices.',
            'Cuisson : Gaufrier → croustillant extérieur, moelleux intérieur.',
            'Crème fumée : Fouette crème + citron + Rouge Obsidienne.',
            'Service : Gaufre chaude + quenelle de crème.'
          ],
          accompagnements: [
            'Salade de tomates rôties, oignons rouges marinés.'
          ],
          boissons: [
            'Cidre brut • Vin blanc fumé • Cocktail mezcal–citron.'
          ],
          pourquoi: 'Il sublime le maïs grillé, amplifie la sensation braisée, et crée un contraste incroyable avec la crème froide.',
          bonusChef: 'Ajoute quelques grains de maïs brûlé sur le dessus pour le croquant.',
          dressage: 'Assiette large, gaufre à moitié nappée de crème, piment d\'Amazonie en poussière fine.'
        }
      }
    ],
    astuceChef: 'Ajouter en fin de cuisson pour révéler toute la fumée et préserver les arômes volatils.'
  },
  {
    id: 'eveil-floral',
    nom: 'Éveil Floral',
    description: 'Mélange citronné et floral, parfait pour viandes blanches et poissons.',
    image: '/images/eveil-floral.jpg',
    composition: [
      {
        nom: 'Sel rose de l\'Himalaya',
        image: '/images/sel-rose-himalaya.jpg',
        bienfaits: 'Riche en minéraux, saveur douce et subtile'
      },
      {
        nom: 'Poivre de Timut',
        image: '/images/poivre-timut.jpg',
        bienfaits: 'Notes citronnées uniques, moins piquant, très aromatique'
      },
      {
        nom: 'Cardamome',
        image: '/images/cardamome.jpg',
        bienfaits: 'Saveur douce et florale, parfait pour les plats délicats'
      },
      {
        nom: 'Coriandre',
        image: '/images/coriandre.jpg',
        bienfaits: 'Notes fraîches et herbacées, très polyvalent'
      },
      {
        nom: 'Sumac',
        image: '/images/sumac.jpg',
        bienfaits: 'Acidité naturelle et notes citronnées, parfait pour équilibrer'
      },
      {
        nom: 'Basilic',
        image: '/images/basilic.jpg',
        bienfaits: 'Aromatique et frais, apporte une touche méditerranéenne'
      },
      {
        nom: 'Gingembre',
        image: '/images/gingembre.jpg',
        bienfaits: 'Saveur chaude et piquante, apporte du dynamisme et de la fraîcheur'
      }
    ],
    idealesAvec: [
      'Poulet grillé',
      'Dorade',
      'Tofu',
      'Salades',
      'Brochettes de légumes',
      'Poissons blancs',
      'Crustacés'
    ],
    recettes: [
      {
        titre: 'Filet mignon rôti au citron confit & Éveil Floral',
        description: 'Un plat doux, citronné, parfumé, minéral, avec une viande ultra tendre et une croûte dorée pleine de caractère. Éveil Floral sans alourdir. C\'est le plat qu\'on ne voit pas venir… mais qu\'on refera souvent.',
        image: '/images/recette-eveil-floral-filet-mignon-citron-confit.jpg',
        details: {
          ingredients: [
            "1 filet mignon de porc (env. 500–600g)",
            "2 c. à café bombées de Éveil Floral (✨ pour marinade + cuisson)",
            "2 c. à soupe d'huile d'olive",
            "1 c. à café de miel ou sirop d'agave",
            "1/2 citron confit (ou zestes de citron jaune très finement hachés)",
            "1 oignon rouge",
            "Quelques brins de thym frais ou de romarin (option)",
            "Sel rose de l'Himalaya (uniquement si besoin)"
          ],
          preparation: [
            "Prépare la marinade sèche : Mélange dans un petit bol 2 c. à café de Éveil Floral, 1 c. à café de miel, 2 c. à soupe d'huile d'olive, 1 c. à café de citron confit haché. Enduis-en le filet mignon sur toute sa surface. Laisse mariner 30 min à température ambiante (ou 1h au frais).",
            "Saisis la viande : Dans une cocotte ou poêle bien chaude, fais dorer le filet mignon sur toutes ses faces (2-3 min de chaque côté). Ajoute l'oignon rouge émincé, les herbes, un fond d'eau (ou un filet de vin blanc), couvre.",
            "Cuisson au four ou à la cocotte : Enfourne à 180°C pendant 20 à 25 min ou poursuis à couvert à feu doux. Arrose de jus de cuisson à mi-cuisson. Laisse reposer 5 minutes hors du feu avant de trancher."
          ],
          accompagnements: [
            "Polenta crémeuse au thym ou au citron",
            "Écrasé de pommes de terre à l'huile d'olive",
            "Purée de panais, navet ou céleri-rave",
            "Salade tiède de lentilles vertes & herbes fraîches"
          ],
          boissons: [
            "Vin blanc sec aromatique (Viognier, Rolle, Chablis tendre)",
            "Cidre brut floral (type artisanal fermier)",
            "Eau infusée citron-thym",
            "Thé glacé au basilic & citron vert"
          ],
          pourquoi: "Crée une croûte aromatique subtilement acidulée et florale, sans jamais dominer. Équilibre la douceur du miel, le gras du porc, et la vivacité du citron. Donne un goût signature élégant, pur, printanier. C'est une assiette qui sort du confort habituel… pour aller vers le raffinement accessible.",
          bonusChef: "Pour un effet gastro : tranche le filet, nappe avec une réduction de jus citron-miel-Éveil Floral, et sers avec quelques zestes confits.",
          dressage: "Assiette blanche ou ardoise pour faire ressortir la croûte dorée. Filet tranché en biais, nappé de jus de cuisson. Quelques feuilles de thym, rondelles d'oignon rôties et zestes en finition. Saupoudrage sec de Éveil Floral sur le bord de l'assiette pour l'arôme à l'approche."
        }
      },
      {
        titre: 'Tartare de pêche blanche, burrata',
        description: 'Une entrée aussi simple que bluffante. La pêche juteuse, la burrata onctueuse, et Éveil Floral pour l\'équilibre entre acidité, douceur, floralité et minéralité.',
        image: '/images/recette-eveil-floral-tartare-peche-burrata.jpg',
        details: {
          ingredients: [
            '2 pêches blanches mûres mais fermes',
            '1 burrata bien fraîche (environ 125 g)',
            '1 c. à café bombée de Éveil Floral (✨ le twist indispensable)',
            '1 filet d\'huile d\'olive de qualité',
            'Le jus d\'1/2 citron vert',
            'Quelques feuilles de basilic frais (ou menthe)',
            'Fleurs comestibles ou pousses si dispo (option pour le visuel)',
            'Poivre noir du moulin (optionnel)'
          ],
          preparation: [
            'Coupe les pêches en petits dés réguliers (façon tartare).',
            'Assaisonne-les dans un bol avec le jus de citron vert, 1/2 c. à café d\'Éveil Floral, un filet d\'huile d\'olive. Laisse reposer au frais 10 min.',
            'Dresse l\'assiette : Dépose la burrata entière au centre (ou en morceaux pour un effet plus sauvage), dispose le tartare de pêche autour ou sur le côté, arrose d\'un peu d\'huile d\'olive + 1/2 c. à café supplémentaire d\'Éveil Floral, ajoute quelques feuilles de basilic et, si dispo, des fleurs comestibles ou pousses.'
          ],
          accompagnements: [],
          boissons: [
            'Verre de vin blanc floral sec (Rolle, Viognier, ou muscat sec)',
            'Cocktail spritz blanc : prosecco, liqueur de sureau, citron',
            'Eau pétillante + infusion verveine + citron',
            'Thé glacé jasmin / pêche blanche / zeste de citron vert'
          ],
          pourquoi: 'Éveil Floral apporte une note florale et citronnée qui équilibre la douceur de la pêche et la richesse de la burrata. Il donne un twist printanier et frais à une entrée simple.',
          bonusChef: 'Ajoute quelques fleurs comestibles pour le visuel et une touche de fleur de sel pour sublimer la burrata.',
          dressage: 'Dresse la burrata au centre, le tartare autour, arrose d\'un filet d\'huile d\'olive et saupoudre d\'Éveil Floral juste avant de servir. Décore avec des pousses ou fleurs.'
        }
      },
      {
        titre: 'Œuf mollet croustillant, purée de petits pois',
        description: 'Une bouchée poétique : croustillant doré, cœur coulant, purée verte aérienne et parfum floral citronné.',
        image: '/images/recette-eveil-floral-oeuf-croustillant-petits-pois.jpg',
        details: {
          ingredients: [
            '2 œufs extra-frais',
            'Farine, œuf battu, chapelure panko',
            'Huile de friture ou d\'olive pour cuisson',
            '200 g de petits pois (frais ou surgelés)',
            '1 c. à soupe d\'huile d\'olive douce',
            'Le jus d\'1/2 citron jaune',
            '1,5 c. à café de Éveil Floral (✨ mélange au cœur du goût)',
            'Sel rose de l\'Himalaya (uniquement si besoin)',
            'Quelques feuilles d\'herbes fraîches (cerfeuil, menthe, basilic)',
            'Zeste de citron jaune',
            'Fleurs comestibles (option visuel 💫)',
            'Un soupçon de Éveil Floral en topping'
          ],
          preparation: [
            'Œufs mollets croustillants : Plonge les œufs dans l\'eau bouillante 6 minutes, puis dans de l\'eau glacée pour stopper la cuisson. Écale-les doucement. Pane-les : farine → œuf battu → chapelure panko. Réserve.',
            'Purée de petits pois : Fais cuire les petits pois 3-4 minutes dans de l\'eau bouillante salée. Égoutte, mixe avec huile, jus de citron, et 1,5 c. à café de Éveil Floral. La texture doit être lisse, souple, légèrement citronnée, très verte et parfumée.',
            'Cuisson finale des œufs : Fais frire dans l\'huile chaude ou à la poêle avec un peu de matière grasse : 1 à 2 min max jusqu\'à belle coloration. Égoutte sur papier absorbant.',
            'Dressage : Purée au centre de l\'assiette, œuf croustillant posé dessus, ajoute zeste de citron, herbes fraîches, fleurs si dispo, finition : 1 pincée de Éveil Floral en topping sec.'
          ],
          accompagnements: [],
          boissons: [
            'Crémant brut ou champagne blanc de blancs',
            'Vin blanc floral et minéral (Riesling sec, Rolle, Vermentino)',
            'Eau pétillante + infusion de verveine & citron',
            'Kombucha floral léger (jasmin, sureau)'
          ],
          pourquoi: 'Éveil Floral apporte une fraîcheur citronnée et florale qui sublime la douceur des petits pois et la gourmandise de l\'œuf croustillant.',
          bonusChef: 'Ajoute quelques zestes de citron et des fleurs comestibles pour un effet visuel poétique.',
          dressage: 'Purée verte au centre, œuf croustillant dessus, zeste de citron, herbes fraîches et fleurs en finition. Saupoudre d\'Éveil Floral juste avant de servir.'
        }
      },
      {
        titre: 'Gravlax de truite au gin',
        description: 'Un filet cru qui prend le goût du voyage. Mariné à froid avec gin, zeste de citron, sel rose, sucre brut et Éveil Floral.',
        image: '/images/recette-eveil-floral-gravlax-truite-gin.jpg',
        details: {
          ingredients: [
            '1 filet de truite ou de saumon bien frais, sans arêtes (env. 300–400g)',
            '2 c. à soupe de Éveil Floral (✨ pour l\'enrobage complet)',
            '2 c. à soupe de sel rose de l\'Himalaya',
            '1 c. à soupe de sucre brun ou de coco',
            'Le zeste d\'1 citron jaune',
            '2 c. à soupe de gin (sec, aromatique type Hendrick\'s, Citadelle, etc.)',
            'Quelques branches d\'aneth ou de coriandre (facultatif)'
          ],
          preparation: [
            'Mélange de marinade sèche : Dans un bol, combine Éveil Floral + sel rose + sucre + zeste. Ajoute les 2 c. à soupe de gin et mélange : tu obtiens une pâte aromatique à étaler.',
            'Prépare le poisson : Dépose le filet côté peau dans un plat ou sur film alimentaire. Étale toute la marinade sur la chair, en massant bien pour l\'enrober.',
            'Laisse mariner : Filme bien ou recouvre d\'un poids léger (planche + boîte de conserve) pour presser. Laisse 12 à 24h au frigo selon l\'intensité souhaitée. Plus tu attends, plus c\'est ferme & parfumé.',
            'Rinçage & finition : Retire la marinade, rince rapidement à l\'eau froide puis éponge bien. Tranche finement en biais comme un saumon fumé.'
          ],
          accompagnements: [
            'Blini à la crème citronnée',
            'Tartine pain noir + ricotta + herbes fraîches',
            'Quelques baies roses concassées ou fleurs comestibles au moment du service'
          ],
          boissons: [
            'Gin tonic léger aux herbes',
            'Verre de Muscadet ou de Chablis',
            'Cocktail blanc type "French 75" (gin, citron, champagne)',
            'Eau pétillante + zestes + infusion de coriandre fraîche',
            'Thé blanc glacé au citron & fleurs de sureau'
          ],
          pourquoi: 'Éveil Floral apporte une note florale et citronnée qui équilibre la puissance du gin et la douceur du poisson. Il donne une signature fraîche et originale à ce gravlax.',
          bonusChef: 'Ajoute quelques baies roses concassées et des fleurs comestibles au moment du service pour la couleur et le croquant.',
          dressage: 'Tranches fines disposées en rosace, accompagnées de blinis et de crème citronnée. Fleurs comestibles et zestes de citron en finition.'
        }
      },
      {
        titre: 'Chèvre chaud rôti au miel sur pain de seigle',
        description: 'Une bouchée qui caresse le palais. Le chèvre fondant, le pain grillé, le miel doré… et le mélange Éveil Floral.',
        image: '/images/recette-eveil-floral-chevre-chaud-miel-seigle.jpg',
        details: {
          ingredients: [
            '2 palets de fromage de chèvre frais (type Sainte-Maure, Rocamadour, crottin affiné)',
            '2 tranches épaisses de pain de seigle ou pain aux céréales',
            '2 c. à café de Éveil Floral (✨ 1 par palet + finition)',
            '1 c. à soupe de miel (liquide ou crémeux)',
            'Un peu d\'huile d\'olive (option)',
            'Noix ou graines grillées pour le croquant (optionnel)',
            'Herbes fraîches ou fleurs comestibles pour le visuel'
          ],
          preparation: [
            'Prépare le pain : Coupe les tranches en deux (4 toasts). Fais-les griller à sec ou au grille-pain. Tu veux du croustillant !',
            'Chauffe le chèvre : Dépose les palets de chèvre sur un plat allant au four. Arrose-les d\'un filet de miel + 1 c. à café de Éveil Floral chacun. Passe sous le grill 5 à 7 min → le dessus doit légèrement caraméliser, le cœur doit fondre.',
            'Montage : Dépose un palet de chèvre rôti sur chaque toast. Ajoute un filet de miel ou d\'huile d\'olive si besoin. Finis avec un soupçon d\'Éveil Floral en topping sec, quelques noix concassées, et des herbes fraîches.'
          ],
          accompagnements: [
            'Mini-toasts ou croustilles au sarrasin',
            'Salade signature : roquette, figues fraîches, huile de noix et vinaigre de cidre'
          ],
          boissons: [
            'Vin blanc moelleux sec (type Jurançon sec ou Chenin de Loire)',
            'Vin orange ou rosé de gastronomie',
            'Bière blanche artisanale au sureau',
            'Eau pétillante + zeste de citron + sirop de fleur de sureau',
            'Thé blanc glacé au miel & thym'
          ],
          pourquoi: 'Éveil Floral apporte une touche florale et citronnée qui équilibre la douceur du miel et la richesse du fromage. Il donne un twist printanier à ce classique.',
          bonusChef: 'Ajoute quelques noix concassées et des herbes fraîches juste avant de servir pour le croquant et la fraîcheur.',
          dressage: 'Toasts croustillants, chèvre doré dessus, filet de miel, herbes fraîches et Éveil Floral en topping. Présente sur une planche ou une assiette rustique.'
        }
      },
      {
        titre: 'Encornets farcis aux herbes fraîches',
        description: 'Un plat aux saveurs d\'ailleurs, comme une escale en Méditerranée — mais twistée par un jardin d\'herbes sauvages.',
        image: '/images/recette-eveil-floral-encornets-herbes.jpg',
        details: {
          ingredients: [
            '4 encornets moyens ou 2 gros tubes d\'encornet vidés et nettoyés',
            '1 échalote',
            '1 petite courgette',
            '1 poignée de riz cuit (env. 60g)',
            '1 c. à soupe d\'herbes fraîches hachées (persil, basilic, menthe)',
            '1 c. à café de Éveil Floral (✨ dans la farce)',
            '1 filet d\'huile d\'olive',
            'Sel, poivre',
            '1 tomate bien mûre ou 1 petite boîte de concassé de tomate',
            '1 c. à café de Éveil Floral (✨ dans la sauce)',
            'Zeste de citron jaune',
            '1 trait de vin blanc sec ou d\'eau',
            '1 gousse d\'ail, un peu de thym'
          ],
          preparation: [
            'Prépare la farce : Hache l\'échalote et la courgette très finement. Fais-les revenir 3 min à la poêle avec un filet d\'huile. Hors feu, ajoute : riz cuit, herbes hachées, 1 c. à café de Éveil Floral, sel et poivre.',
            'Farcis les encornets : Remplis chaque encornet avec la farce (ne tasse pas trop, ça gonfle à la cuisson). Ferme avec un cure-dent ou replie simplement.',
            'Prépare le jus de cuisson : Dans une poêle ou sauteuse : fais revenir ail + tomate + zeste de citron. Ajoute 1 c. à café de Éveil Floral, thym et un trait de vin blanc. Laisse mijoter 5 min.',
            'Cuisson des encornets : Dépose les encornets dans le jus. Couvre et laisse mijoter à feu doux 15 à 20 min, en arrosant de temps en temps.'
          ],
          accompagnements: [
            'Riz pilaf aux zestes de citron',
            'Écrasé de pommes de terre à l\'huile d\'olive',
            'Focaccia chaude ou pain grillé à l\'ail',
            'Salade d\'herbes fraîches (basilic, coriandre, menthe)'
          ],
          boissons: [
            'Vermentino ou Muscadet sur lie',
            'Vin orange sec, aux notes d\'agrumes',
            'Spritz au basilic & citron confit',
            'Eau gazeuse citron–menthe',
            'Kombucha floral (jasmin, camomille, basilic sacré)'
          ],
          pourquoi: 'Éveil Floral apporte une fraîcheur citronnée et florale qui twiste la farce et la sauce, pour un plat méditerranéen revisité.',
          bonusChef: 'Ajoute des zestes de citron frais et des herbes juste avant de servir pour la couleur et la fraîcheur.',
          dressage: 'Encornets tranchés en biais, disposés sur un lit de sauce, herbes fraîches et zestes en finition. Présente sur une assiette blanche ou bleue.'
        }
      },
      {
        titre: 'Crème citron-pêche rôtie & sablé au sarrasin',
        description: 'Un dessert fin, fondant, citronné, légèrement floral, invitation à la douceur végétale.',
        image: '/images/recette-eveil-floral-creme-citron-peche-sarrasin.jpg',
        details: {
          ingredients: [
            '1 œuf',
            'Le jus d\'1 citron jaune',
            '1 c. à soupe de miel doux ou sucre blond',
            '1 c. à soupe de beurre doux ou huile de coco',
            '1/2 c. à café de Éveil Floral',
            '1 pêche mûre',
            '1 c. à café de miel',
            '1/2 c. à café de Éveil Floral',
            '40 g de farine de sarrasin',
            '20 g de beurre',
            '10 g de sucre',
            '1 pincée de sel'
          ],
          preparation: [
            'Crème citron Éveil Floral : Dans une petite casserole, fouette l\'œuf, le jus de citron, le miel, et 1/2 c. à café de Éveil Floral. Cuire à feu doux sans cesser de mélanger jusqu\'à ce que la crème épaississe. Hors feu, ajoute le beurre, fouette, filme au contact, laisse refroidir.',
            'Pêches rôties : Coupe la pêche en quartiers. Passe à la poêle avec 1 c. à café de miel + 1/2 c. à café d\'Éveil Floral → laisse caraméliser légèrement. Réserve.',
            'Sablé express (optionnel mais crousti-whaou) : Mélange tous les ingrédients à la main → forme une boule. Étale finement, découpe en cercle ou émiette, et fais cuire 10-12 min à 180°C.',
            'Dressage : crème citron au fond, dés de pêche rôtie, sablé concassé ou en tuiles, zeste de citron râpé, pincée de Éveil Floral sec, mini feuille de menthe.'
          ],
          accompagnements: [],
          boissons: [
            'Vin moelleux type Jurançon ou Muscat sec',
            'Cocktail à base de gin, citron, liqueur de fleur de sureau',
            'Eau pétillante + sirop maison de citron & verveine',
            'Thé blanc glacé au miel & poivre timut'
          ],
          pourquoi: 'Éveil Floral apporte une note florale et citronnée qui twiste la crème et les pêches rôties, pour un dessert frais et végétal.',
          bonusChef: 'Ajoute quelques zestes de citron et une mini feuille de menthe pour la fraîcheur et la couleur.',
          dressage: 'Crème citron au fond, dés de pêche rôtie, sablé concassé ou en tuiles, zeste de citron râpé, pincée de Éveil Floral sec, mini feuille de menthe.'
        }
      },
      {
        titre: 'Gnocchis croustillants au yaourt fouetté, huile chaude & Éveil Floral',
        description: 'Pour 4 personnes — Un contraste chaud/froid exceptionnel : gnocchis dorés, yaourt fouetté glacé, huile chaude versée dessus pour libérer le parfum floral.',
        image: '/images/gnocchis-yaourt-eveil-floral.jpg',
        details: {
          ingredients: [
            '600 g de gnocchis frais',
            '250 g de yaourt grec très froid',
            '1 c. à soupe de citron confit haché fin',
            '1 c. à café bombée d\'Éveil Floral',
            '5 c. à soupe d\'huile d\'olive',
            '1 gousse d\'ail',
            'Sel léger, poivre blanc'
          ],
          preparation: [
            'Yaourt fouetté : Fouette le yaourt + citron confit + une pincée d\'Éveil Floral jusqu\'à texture mousseuse. Garde au frigo.',
            'Gnocchis croustillants : Poêle large, huile d\'olive → gnocchis 8–10 min jusqu\'à croûte dorée.',
            'Huile chaude aromatique : Chauffe 4 c. à soupe d\'huile avec l\'ail écrasé. Hors feu, ajoute le reste d\'Éveil Floral.',
            'Montage : Mousse de yaourt au fond, gnocchis brûlants dessus.',
            'Explosion : Verse l\'huile chaude florale juste avant de servir.'
          ],
          accompagnements: [
            'Roquette citronnée, pickles de fenouil.'
          ],
          boissons: [
            'Vermentino • Bière blanche coriandre • Thé glacé bergamote.'
          ],
          pourquoi: 'Il adore la chaleur de l\'huile → explosion d\'arômes floraux instantanée.',
          bonusChef: 'Ajoute un zeste de pamplemousse pour une pointe d\'amertume noble.',
          dressage: 'Assiette creuse, yaourt blanc éclatant, gnocchis dorés, huile dorée ponctuée d\'herbes.'
        }
      },
      {
        titre: 'Carpaccio de noix de Saint-Jacques au lait fermenté & Éveil Floral',
        description: 'Pour 4 personnes — Fraîcheur absolue : coquilles crues, lait fermenté, agrumes, parfum floral vibrant. Une entrée de chef, mais simple à faire.',
        image: '/images/carpaccio-saint-jacques-eveil-floral.jpg',
        details: {
          ingredients: [
            '12 noix de Saint-Jacques ultra fraîches',
            '15 cl de lait fermenté (type lait ribot)',
            'Le zeste d\'un citron jaune + d\'un citron vert',
            '1 c. à café d\'Éveil Floral',
            '1 c. à soupe d\'huile de pépins de raisin',
            'Fleur de sel'
          ],
          preparation: [
            'Tranchage : Coupe les Saint-Jacques en fines lamelles.',
            'Lacté citronné : Mélange lait fermenté + zestes + ½ c. café d\'Éveil Floral.',
            'Montage : Étale les coquilles en rosace, nappe avec le lait fermenté.',
            'Finition : Huile neutre + fleur de sel + reste d\'Éveil Floral.',
            'Repos : 3 min MAX pour que l\'acidité "cuit" légèrement.'
          ],
          accompagnements: [
            'Pastille de concombre, pains plats grillés.'
          ],
          boissons: [
            'Blanc minéral (Sancerre) • Gin tonic floral • Eau glacée citron–verveine.'
          ],
          pourquoi: 'Ses agrumes et notes florales renforcent la douceur iodée des Saint-Jacques sans écraser le cru.',
          bonusChef: 'Ajoute quelques grains de grenade pour une touche brillante.',
          dressage: 'Assiette très froide, rosace parfaite, gouttes vertes de zeste.'
        }
      },
      {
        titre: 'Soupe froide de courgette brûlée, amande blanche & Éveil Floral',
        description: 'Pour 4 personnes — Une soupe froide hyper moderne : courgette grillée pour la profondeur, amande pour la rondeur, Éveil Floral pour la fraîcheur incisive.',
        image: '/images/soupe-courgette-eveil-floral.jpg',
        details: {
          ingredients: [
            '4 courgettes',
            '1 gousse d\'ail',
            '40 g d\'amandes blanches',
            '40 cl de bouillon froid',
            '2 c. à café d\'Éveil Floral',
            '2 c. à soupe d\'huile d\'olive',
            'Sel léger'
          ],
          preparation: [
            'Courgettes brûlées : Poêle très chaude → grillées jusqu\'à marques noires.',
            'Mixage : Mixe courgettes + amandes + ail + bouillon froid.',
            'Soin aromatique : Ajoute Éveil Floral hors mixage principal pour préserver le floral.',
            'Repos : 30 min au frais.',
            'Service : Fouette légèrement pour redonner du volume.'
          ],
          accompagnements: [
            'Croûtons citron–huile d\'olive, herbes fraîches (cerfeuil, basilic).'
          ],
          boissons: [
            'Petit blanc sec • Bière IPA légère aux agrumes • Kombucha fleurs blanches.'
          ],
          pourquoi: 'Il crée une tension magnifique entre la courgette grillée et la douceur des amandes.',
          bonusChef: 'Ajoute 2 gouttes d\'huile d\'amande douce sur chaque bol.',
          dressage: 'Bol froid, surface lisse vert pâle, gouttes d\'huile, zestes fins.'
        }
      },
      {
        titre: 'Crevettes crousti-fondantes au miel, verveine & Éveil Floral',
        description: 'Pour 4 personnes — Une cuisson flash, laqué léger miel-verveine, relevé d\'un floral acidulé spectaculaire.',
        image: '/images/crevettes-verveine-eveil-floral.jpg',
        details: {
          ingredients: [
            '600 g de crevettes décortiquées',
            '1 c. à café d\'Éveil Floral',
            '1 c. à soupe de miel',
            '10 cl d\'eau',
            '6 feuilles de verveine fraîche',
            '1 c. à soupe d\'huile neutre',
            'Sel très léger'
          ],
          preparation: [
            'Infusion : Chauffe eau + verveine + miel → 5 min → retire verveine.',
            'Saisie : Poêle très chaude, crevettes 1 min.',
            'Laquage : Verse l\'infusion → réduit 1 min.',
            'Éveil Floral : Ajoute-le hors feu pour garder son parfum intact.',
            'Service : Mélange et envoie immédiatement.'
          ],
          accompagnements: [
            'Riz jasmin, salade mangue–concombre, herbes fraîches.'
          ],
          boissons: [
            'Gewurztraminer sec • Cocktail citron–verveine • Eau pétillante à l\'orange.'
          ],
          pourquoi: 'Parce qu\'il prolonge naturellement la verveine et crée un laquage léger mais explosif en arômes.',
          bonusChef: 'Zeste de combava si tu veux un parfum encore plus vibrant.',
          dressage: 'Assiette claire, crevettes vernies, herbes éparpillées, zeste en pluie.'
        }
      },
      {
        titre: 'Tartare d\'avocat à la clémentine, huile vanillée & Éveil Floral',
        description: 'Pour 4 personnes — Un tartare sucré-salé, floral et agrumé, d\'une finesse rare. Texture crémeuse, notes cítriques, parfum délicat.',
        image: '/images/tartare-avocat-clementine-eveil-floral.jpg',
        details: {
          ingredients: [
            '3 gros avocats',
            '3 clémentines',
            '1 c. à café rase d\'Éveil Floral',
            '1 c. à soupe de jus de citron vert',
            '2 c. à soupe d\'huile d\'olive infusée vanille (ou vanille en poudre)',
            'Fleur de sel'
          ],
          preparation: [
            'Avocat : Couper en dés, arroser immédiatement de citron vert.',
            'Agrumes : Prélever suprêmes de clémentine, couper en petits morceaux.',
            'Assemblage : Mélange avocat + clémentine + huile vanillée.',
            'Éveil Floral : Ajouter juste avant de servir pour garder toute la fraîcheur.',
            'Repos : 5 min pour que les parfums se marient.'
          ],
          accompagnements: [
            'Crackers aux graines, salade d\'herbes douces, burrata en topping (version luxe).'
          ],
          boissons: [
            'Prosecco brut • Cocktail gin–clementine • Thé glacé vanille–bergamote.'
          ],
          pourquoi: 'Il structure la douceur de l\'avocat et exalte les agrumes.',
          bonusChef: 'Ajoute quelques zestes de clémentine au dernier moment.',
          dressage: 'Emporte-pièce, tartare cylindrique, huile brillante, zestes scintillants.'
        }
      }
    ],
    astuceChef: 'Ajoute une pincée à une sauce vierge pour une base légère et aromatique.'
  },
  {
    id: 'bois-fauve',
    nom: 'Bois Fauve',
    description: 'Mélange boisé et végétal pour légumes rôtis, viandes blanches, champignons.',
    image: '/images/bois-fauve.jpg',
    composition: [
      {
        nom: 'Sel rouge d\'Hawaï',
        image: '/images/sel-rouge-hawai.jpg',
        bienfaits: 'Saveur douce et minérale, couleur rouge naturelle'
      },
      {
        nom: 'Poivre de Malabar',
        image: '/images/poivre-malabar.jpg',
        bienfaits: 'Poivre noir classique, saveur chaude et équilibrée'
      },
      {
        nom: 'Coriandre',
        image: '/images/coriandre.jpg',
        bienfaits: 'Notes fraîches et herbacées, très polyvalent'
      },
      {
        nom: 'Cumin',
        image: '/images/cumin.jpg',
        bienfaits: 'Saveur chaude et terreuse, parfait pour les légumes'
      },
      {
        nom: 'Piment de la Jamaïque',
        image: '/images/piment-jamaique.jpg',
        bienfaits: 'Notes de cannelle, muscade et clou de girofle réunies'
      },
      {
        nom: 'Thym',
        image: '/images/thym.jpg',
        bienfaits: 'Aromatique et boisé, parfait pour les plats mijotés'
      },
      {
        nom: 'Romarin',
        image: '/images/romarin.jpg',
        bienfaits: 'Saveur résineuse et forte, idéal pour les viandes et légumes'
      },
      {
        nom: 'Ail semoule',
        image: '/images/ail-semoule.jpg',
        bienfaits: 'Saveur profonde et réconfortante, parfait pour les plats mijotés'
      }
    ],
    idealesAvec: [
      'Poulet rôti',
      'Légumes racines',
      'Champignons',
      'Gratins',
      'Pommes de terre',
      'Agneau',
      'Légumes d\'hiver'
    ],
    recettes: [
      // 1. Tarte fine aux champignons sauvages & crème
      {
        titre: 'Tarte fine aux champignons sauvages & crème',
        description: 'Une entrée croustillante, élégante, qui évoque la fraîcheur du sous-bois.',
        image: '/images/tarte-fine-champignons-bois-fauve.jpg',
        details: {
          ingredients: [
            '1 pâte feuilletée rectangulaire',
            '200g de champignons mélangés (shiitakés, pleurotes, champignons de Paris…)',
            '2 c. à soupe de mascarpone',
            '1 c. à café bombée de Bois Fauve',
            '1 c. à soupe d\'huile de noisette (ou olive)',
            'Zeste de citron',
            'Quelques brins de persil plat frais'
          ],
          preparation: [
            'Fais revenir les champignons à feu vif dans un filet d\'huile, jusqu\'à ce qu\'ils soient bien dorés et légèrement croustillants.',
            'Mélange le mascarpone avec Bois Fauve, un trait d\'huile de noisette et une pincée de zeste de citron. Goûte. Ajuste si besoin.',
            'Déroule la pâte feuilletée. Étale la crème au centre en laissant un bord. Dispose les champignons dessus.',
            'Enfourne à 200°C pendant 15-20 minutes, jusqu\'à ce que les bords soient bien dorés.',
            'Sers tiède, avec quelques pluches de persil, un filet d\'huile de noisette et un tour de moulin à poivre.'
          ],
          pourquoi: 'Bois Fauve structure le goût : profondeur boisée + notes végétales. Il révèle les champignons sans les dominer. Il remplace la noix de muscade, le poivre, le sel, et donne une vraie signature de chef. Tu transformes une simple tarte aux champignons en moment automnal d\'exception.',
          bonusChef: 'Pour un effet gastro, ajoute quelques copeaux de vieux comté ou de parmesan juste avant de servir.',
          boissons: [
            'Vin blanc sec type Sancerre, ou vin jaune du Jura',
            'Infusion glacée de thym, citron vert & pointe de miel (sans alcool)'
          ],
          dressage: 'Tarte rectangulaire servie sur une grande planche ou assiette foncée. Fines herbes dispersées à la main. Filet d\'huile en zigzag, et micro-pousses si tu veux jouer la carte gastro.'
        }
      },
      // 2. Poulet rôti & légumes racines façon "clairière d'automne"
      {
        titre: 'Poulet rôti & légumes racines façon "clairière d\'automne"',
        description: 'Un plat simple et poétique, qui sent bon la cuisine du dimanche… mais twistée avec Bois Fauve.',
        image: '/images/poulet-legumes-racines-bois-fauve.jpg',
        details: {
          ingredients: [
            '2 cuisses de poulet fermier, avec peau',
            '2 carottes, 1 panais, 1 petite patate douce',
            '1 c. à soupe bombée de Bois Fauve',
            '2 c. à soupe d\'huile d\'olive',
            'Quelques branches de thym frais'
          ],
          preparation: [
            'Dans un bol, mélange Bois Fauve avec l\'huile. Masse bien les cuisses de poulet avec cette huile épicée.',
            'Épluche et coupe les légumes en gros quartiers. Dispose-les dans un plat à four avec un filet d\'huile, du sel et un soupçon de Bois Fauve.',
            'Dispose le poulet au centre, peau vers le haut. Ajoute les branches de thym.',
            'Enfourne à 190°C pendant 45 à 55 minutes, en arrosant régulièrement avec le jus.',
            'Quand tout est bien doré et fondant, sers chaud, directement dans le plat.'
          ],
          pourquoi: 'Bois Fauve remplace sel, poivre, thym, cumin et oignon à lui seul. Il donne une cohérence aromatique totale entre le poulet et les légumes. Il apporte cette chaleur boisée et rassurante, parfaite pour les plats d\'automne ou d\'hiver. Un plat rustique mais noble, chaleureux, parfaitement équilibré.',
          bonusChef: 'Ajoute quelques noisettes torréfiées ou graines de courge grillées sur les légumes avant de servir.',
          boissons: [
            'Vin rouge léger type Gamay ou Pinot Noir',
            'Jus de pomme brut avec une feuille de sauge ou un trait de vinaigre de cidre (sans alcool)'
          ],
          dressage: 'Grand plat en céramique rustique ou planche de bois. Herbes fraîches en touche finale. Légumes rôtis empilés en cascade, poulet dressé sur le dessus.'
        }
      },
      // 3. Poêlée rustique de lentilles vertes, œuf mollet
      {
        titre: 'Poêlée rustique de lentilles vertes, œuf mollet',
        description: 'Une assiette végétarienne réconfortante, ancrée dans la terre.',
        image: '/images/poelee-lentilles-oeuf-bois-fauve.jpg',
        details: {
          ingredients: [
            '160g de lentilles vertes du Puy',
            '1 carotte, 1 petit oignon',
            '2 œufs',
            '1 c. à soupe d\'huile d\'olive',
            '1 c. à café bombée de Bois Fauve',
            'Persil plat ou coriandre fraîche'
          ],
          preparation: [
            'Fais revenir l\'oignon et la carotte hachés avec un filet d\'huile. Ajoute les lentilles rincées, couvre d\'eau, ajoute Bois Fauve et laisse mijoter 25-30 min jusqu\'à tendreté.',
            'Plonge les œufs dans l\'eau bouillante pendant 6 min. Refroidis-les aussitôt. Écale-les avec soin.',
            'Dispose les lentilles chaudes dans les assiettes. Coupe l\'œuf en deux et pose-le au centre. Ajoute quelques herbes fraîches.'
          ],
          pourquoi: 'Bois Fauve remplace le bouquet garni et le fond de cuisson à lui seul. Il ajoute des notes complexes (cumin, oignon frit, piment doux) sans dominer. Il donne une profondeur qu\'on n\'attend pas dans un plat aussi simple. Avec un seul mélange, tu transformes un plat d\'étudiant en assiette de bistronomie.',
          bonusChef: 'Ajoute un filet de vinaigre balsamique réduit sur l\'œuf pour une touche acidulée.',
          boissons: [
            'Chinon rouge léger, ou vin nature un peu brut',
            'Eau pétillante citronnée + branche de romarin (sans alcool)'
          ],
          dressage: 'Assiette creuse ou bol en céramique. Œuf coulant au centre, herbes en pluie, un tour de moulin à poivre. Pour les plus joueurs : un filet de vinaigre balsamique réduit.'
        }
      },
      // 4. Sauté de porc & oignons caramélisés
      {
        titre: 'Sauté de porc & oignons caramélisés',
        description: 'Un plat mijoté tout doux mais puissant en arômes.',
        image: '/images/saute-porc-oignons-bois-fauve.jpg',
        details: {
          ingredients: [
            '300g d\'échine de porc, coupée en cubes',
            '2 gros oignons jaunes',
            '1 c. à soupe de miel',
            '1 c. à soupe de vinaigre de cidre',
            '1 c. à soupe d\'huile végétale',
            '2 c. à café bombées de Bois Fauve',
            'Sel si besoin (goûter en fin de cuisson)'
          ],
          preparation: [
            'Fais revenir le porc dans l\'huile jusqu\'à coloration. Ajoute Bois Fauve et mélange pour bien enrober.',
            'Ajoute les oignons émincés et le miel. Laisse caraméliser à feu moyen pendant 10 min, en remuant.',
            'Ajoute le vinaigre de cidre + un petit verre d\'eau. Couvre et laisse mijoter à feu doux 20-25 min jusqu\'à ce que le porc soit tendre et la sauce réduite.'
          ],
          pourquoi: 'Bois Fauve apporte la chaleur épicée (piment de Jamaïque, cumin, poivre). Il rehausse le côté sucré-salé des oignons sans être envahissant. Il évite d\'utiliser plusieurs épices séparées, tout est dans le bon dosage. Un plat ultra simple, mais avec un vrai twist de chef.',
          bonusChef: 'Ajoute quelques oignons frits ou herbes fraîches en topping pour la gourmandise.',
          boissons: [
            'Rouge souple et fruité type Brouilly, ou côtes-du-Rhône léger',
            'Infusion pomme-thym-gingembre, servie glacée (sans alcool)'
          ],
          dressage: 'Assiette creuse ou cocotte individuelle. Le porc au centre, nappé du jus caramélisé. Quelques oignons frits ou herbes en topping.'
        }
      },
      // 5. Risotto de courge rôtie
      {
        titre: 'Risotto de courge rôtie',
        description: 'Un plat végétarien onctueux et réconfortant, entre terre et forêt.',
        image: '/images/risotto-courge-bois-fauve.jpg',
        details: {
          ingredients: [
            '150g de riz arborio',
            '250g de courge (butternut ou potimarron)',
            '1 petit oignon',
            '1 c. à soupe de crème ou mascarpone',
            '2 c. à café bombées de Bois Fauve',
            '1 c. à soupe d\'huile d\'olive',
            '1 c. à soupe de parmesan râpé (facultatif)'
          ],
          preparation: [
            'Coupe la courge en dés. Enrobe-les d\'un peu d\'huile + une pincée de Bois Fauve. Rôtis-les au four à 200°C pendant 20 min, jusqu\'à tendreté.',
            'Fais revenir l\'oignon émincé avec un filet d\'huile. Ajoute le riz, nacre-le 1 min. Verse de l\'eau chaude au fur et à mesure, comme un risotto classique. Ajoute Bois Fauve en début de cuisson.',
            'Une fois le riz cuit (18-20 min), ajoute la crème, les dés de courge rôtis, et le parmesan si tu veux plus de rondeur. Mélange bien.'
          ],
          pourquoi: 'Bois Fauve structure le plat sans bouillon : tout est dedans. Il équilibre la douceur de la courge avec des touches chaudes, boisées et légèrement anisées. Il rend ce risotto riche et profond, même sans viande. Un plat de saison élégant et généreux, prêt à impressionner.',
          bonusChef: 'Ajoute quelques graines toastées ou copeaux de parmesan pour la texture.',
          boissons: [
            'Vin blanc structuré et floral type Viognier ou Chardonnay boisé',
            'Eau citronnée tiède avec une branche de sauge ou infusion thym-orange (sans alcool)'
          ],
          dressage: 'Assiette creuse ou bol beige. Courge rôtie sur le dessus. Copeaux de parmesan, pluches d\'herbes ou graines toastées pour la texture.'
        }
      },
      // 6. Sandwich chaud façon "Pastrami forestier"
      {
        titre: 'Sandwich chaud façon "Pastrami forestier"',
        description: 'Un street food à la française, rustique mais chic.',
        image: '/images/sandwich-pastrami-forestier-bois-fauve.jpg',
        details: {
          ingredients: [
            '300g de paleron ou bœuf effiloché (ou restes de rôti)',
            '2 pains type ciabatta ou focaccia',
            '1 oignon rouge émincé',
            '1 c. à soupe bombée de Bois Fauve',
            '1 c. à soupe de crème épaisse ou yaourt grec',
            '1 c. à café de moutarde douce',
            'Quelques pousses d\'épinard ou roquette'
          ],
          preparation: [
            'Réchauffe la viande avec un peu d\'eau, l\'oignon rouge, Bois Fauve, et une noisette de beurre. Laisse mijoter 5-10 min pour bien imprégner les arômes.',
            'Mélange crème + moutarde + une pincée de Bois Fauve pour une sauce fraîche et onctueuse.',
            'Toaste légèrement le pain. Garnis avec la viande chaude, la sauce, les herbes fraîches. Presse légèrement pour faire fondre les saveurs.'
          ],
          pourquoi: 'Bois Fauve donne au bœuf un caractère fumé, épicé et forestier sans ajout d\'autre ingrédient. Il fait le lien entre la sauce et la garniture, comme une colonne vertébrale gustative. Il transforme ce sandwich en petite masterclass de saveurs. Un snack généreux, stylé, qui sent le bois et les épices chaudes.',
          bonusChef: 'Ajoute quelques pickles maison ou chips de légumes pour le croquant.',
          boissons: [
            'Bière ambrée ou IPA douce',
            'Kombucha gingembre-citron ou jus de betterave-pomme (sans alcool)'
          ],
          dressage: 'Sandwich coupé en deux, posé sur une planche en bois. Servi avec quelques chips de légumes ou pickles maison. Un brin de thym ou romarin à côté pour l\'ambiance.'
        }
      },
      // 7. Cookies chocolat noir & noisettes grillées
      {
        titre: 'Cookies chocolat noir & noisettes grillées',
        description: 'Le dessert qui surprend. Bois Fauve apporte ce petit "je-ne-sais-quoi" d\'épicé, boisé, presque fumé, qui transforme un cookie classique en douceur haut de gamme.',
        image: '/images/cookies-chocolat-noisettes-bois-fauve.jpg',
        details: {
          ingredients: [
            '120g de beurre doux',
            '100g de sucre roux',
            '1 œuf',
            '150g de farine',
            '80g de chocolat noir concassé (70%)',
            '50g de noisettes entières grillées',
            '1 c. à café rase de Bois Fauve',
            '1/2 c. à café de levure chimique',
            '1 pincée de fleur de sel'
          ],
          preparation: [
            'Mélange le beurre mou et le sucre. Ajoute l\'œuf, puis la farine, la levure, Bois Fauve et la fleur de sel.',
            'Ajoute les pépites de chocolat noir et les noisettes concassées. Forme des boules de pâte.',
            'Dispose sur une plaque, aplatis légèrement. Enfourne à 180°C pendant 10 à 12 min. Laisse tiédir avant de déguster.'
          ],
          pourquoi: 'Bois Fauve ajoute des notes épicées et boisées qui font écho au chocolat noir. Il crée un contraste subtil avec le sucre et le gras des noisettes. Il donne à ces cookies une vraie signature gustative, différente et raffinée. Un dessert d\'automne, de forêt, de feu de bois. À la fois doux, réconfortant… et audacieux.',
          bonusChef: 'Ajoute quelques noisettes entières et éclats de chocolat pour le décor. Sers tiède, idéalement.',
          boissons: [
            'Rhum ambré ou Porto vintage',
            'Lait d\'amande chaud ou infusion rooibos vanille-cannelle (sans alcool)'
          ],
          dressage: 'Posés en pile sur une assiette brute, un peu de cacao saupoudré autour. Quelques noisettes entières et éclats de chocolat pour le décor. À servir tiède, idéalement.'
        }
      },
      // 8. Risotto forestier au Bois Fauve & noisettes torréfiées
      {
        titre: 'Risotto forestier au Bois Fauve & noisettes torréfiées',
        description: 'Pour 4 personnes — Un risotto crémeux et profond où Bois Fauve révèle toute la dimension forestière du plat.',
        image: '/images/risotto-forestier-bois-fauve.jpg',
        details: {
          ingredients: [
            '320 g de riz arborio',
            '600 g de champignons bruns ou shiitakés',
            '1 grosse échalote',
            '2 L de bouillon',
            '80 g de parmesan',
            '2 c. à soupe de noisettes torréfiées',
            '2 c. à café rases de Bois Fauve',
            '1 branche de thym',
            '20 g de beurre',
            'Huile d\'olive, sel léger'
          ],
          preparation: [
            'Poêle échalote + champignons + thym.',
            'Ajoute le riz, nacre 1 min.',
            'Verse le bouillon louche après louche (18–20 min).',
            'Hors feu : beurre + parmesan + Bois Fauve.',
            'Ajoute les noisettes au dernier moment.'
          ],
          accompagnements: [
            'Roquette citronnée, carottes rôties, pecorino.'
          ],
          boissons: [
            'Savagnin, bière ambrée, infusion thym-citron.'
          ],
          pourquoi: 'Il renforce les notes forestières naturelles du plat.',
          bonusChef: 'Une goutte de citron en fin de cuisson.',
          dressage: 'Assiette creuse, noisettes au centre, filet d\'huile.'
        }
      },
      // 9. Poulet rôti au citron confit & Bois Fauve
      {
        titre: 'Poulet rôti au citron confit & Bois Fauve',
        description: 'Pour 4 personnes — Un poulet juteux et parfumé où Bois Fauve s\'infuse sous la peau pour un rôti aromatique.',
        image: '/images/poulet-roti-entier-bois-fauve.jpg',
        details: {
          ingredients: [
            '1 poulet fermier (1,8–2 kg)',
            '2 c. à café bombées de Bois Fauve',
            '2 c. à soupe de citron confit haché',
            '6 gousses d\'ail',
            '1 oignon',
            '1 branche de romarin',
            '3 c. à soupe d\'huile d\'olive',
            'Sel léger'
          ],
          preparation: [
            'Masser poulet : huile + ail + citron confit + Bois Fauve.',
            'Insérer oignon + romarin.',
            'Cuire 1 h 30 à 180°C en arrosant.',
            'Laisser reposer 10 min.',
            'Déglacer pour un jus clair.'
          ],
          accompagnements: [
            'Grenailles rôties, poireaux braisés, salade d\'herbes.'
          ],
          boissons: [
            'Chardonnay boisé léger, bière blonde, infusion romarin-citron.'
          ],
          pourquoi: 'Le mélange se marie parfaitement au citron confit et au romarin.',
          bonusChef: 'Ajoute un peu de Bois Fauve sous la peau des blancs.',
          dressage: 'Poulet entier présenté sur planche, jus en filet.'
        }
      },
      // 10. Œufs cocotte crème–champignons & Bois Fauve
      {
        titre: 'Œufs cocotte crème–champignons & Bois Fauve',
        description: 'Pour 4 personnes — Un mélange crème–champignons–boisé où Bois Fauve apporte une profondeur forestière raffinée.',
        image: '/images/oeufs-cocotte-creme-champignons-bois-fauve.jpg',
        details: {
          ingredients: [
            '8 œufs',
            '300 g de champignons',
            '40 cl de crème',
            '1 c. à café rase de Bois Fauve',
            '1 échalote',
            'Beurre, sel, poivre blanc'
          ],
          preparation: [
            'Poêle échalote + champignons.',
            'Ajoute crème + Bois Fauve 1 min.',
            'Répartis dans 4 ramequins, casse 2 œufs chacun.',
            '10–12 min au bain-marie, 180°C.',
            'Poivre blanc + ciboulette.'
          ],
          accompagnements: [
            'Pain grillé, salade de pousses, beurre d\'herbes.'
          ],
          boissons: [
            'Viognier, cidre brut, infusion sauge-miel.'
          ],
          pourquoi: 'Il amplifie naturellement le goût des champignons.',
          bonusChef: 'Quelques gouttes d\'huile de noix au dernier moment.',
          dressage: 'Ramequin, jaune brillant, pain grillé.'
        }
      },
      // 11. Polenta crémeuse & légumes rôtis, huile Bois Fauve
      {
        titre: 'Polenta crémeuse & légumes rôtis, huile Bois Fauve',
        description: 'Pour 4 personnes — Une assiette végétale réconfortante où Bois Fauve donne structure et profondeur.',
        image: '/images/polenta-cremeuse-legumes-bois-fauve.jpg',
        details: {
          ingredients: [
            '240 g de polenta',
            '1,2 L d\'eau ou bouillon',
            '60 g de parmesan',
            '600 g de légumes rôtis',
            '1 c. à café de Bois Fauve',
            '3 c. à soupe d\'huile d\'olive',
            'Sel léger'
          ],
          preparation: [
            'Cuire polenta dans liquide chaud.',
            'Ajouter parmesan.',
            'Rôtir légumes 35–40 min.',
            'Mélanger huile + Bois Fauve.',
            'Dresser polenta + légumes + huile boisée.'
          ],
          accompagnements: [
            'Endives, graines torréfiées, herbes fraîches.'
          ],
          boissons: [
            'Gamay, bière ambrée, infusion gingembre–thym.'
          ],
          pourquoi: 'Il donne du caractère aux plats doux à base de céréales.',
          bonusChef: 'Un zeste de citron pour réveiller le tout.',
          dressage: 'Bol, légumes au centre, gouttes d\'huile visible.'
        }
      },
      // 12. Tartines ricotta–fenouil & Bois Fauve
      {
        titre: 'Tartines ricotta–fenouil & Bois Fauve',
        description: 'Pour 4 personnes — Une entrée fraîche et aromatique où Bois Fauve sublime le croquant du fenouil.',
        image: '/images/tartinade-ricotta-fenouil-bois-fauve.jpg',
        details: {
          ingredients: [
            '400 g de ricotta',
            '1 gros bulbe de fenouil',
            '1 c. à café de Bois Fauve',
            '2 c. à soupe d\'huile d\'olive',
            'Zeste d\'1 citron',
            'Pain de campagne grillé',
            'Sel léger'
          ],
          preparation: [
            'Mélange ricotta + huile + zeste + Bois Fauve.',
            'Tranche finement le fenouil, sale légèrement.',
            'Tartiner ricotta, ajouter fenouil.',
            'Repos 5 min pour infusion.',
            'Gouttes d\'huile en finition.'
          ],
          accompagnements: [
            'Tomates rôties, olives vertes, salade d\'herbes.'
          ],
          boissons: [
            'Muscadet, pastis léger, eau pétillante fenouil–citron.'
          ],
          pourquoi: 'Le duo boisé–herbacé se marie parfaitement au fenouil cru.',
          bonusChef: 'Un filet de miel pour une note sucrée–boisée.',
          dressage: 'Planche bois, plumes de fenouil, zestes fins.'
        }
      }
    ],
    astuceChef: 'Mélanger avec miel et sauce soja pour une laque maison savoureuse.'
  }
];

export const getMelangeById = (id) => {
  return melanges.find(melange => melange.id === id);
}; 